@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.header {
  display: flex;
  column-gap: var(--collab-item-avatar-gap);
  align-items: flex-start;
  @include md-sohne;
  color: var(--dark-80);
  margin-bottom: 4px;

  @include for-phone-only {
    margin-bottom: 12px;
  }

  p {
    margin-bottom: 0;
  }
}
